import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../../components/home/Header";
import Nav from "../../components/home/Nav";
import { useFilterProductsQuery } from "../../store/services/homeProducts";
import ProductCard from "../../components/home/ProductCard";
import Pagination from "../../components/Pagination";
import ProductSkeleton from "../../components/home/ProductSkeleton";
import ProductFilters from "../../components/home/ProductFilters";
import { toPersianNumber } from "../../utils/persian";
import { trackAnalytics } from "../../utils/analytics";

const SearchProducts = () => {
  const { keyword, page = 1 } = useParams();
  const [mobileFilterOpen, setMobileFilterOpen] = useState(false);

  const [filters, setFilters] = useState({
    q: keyword,
    category: "",
    fixedCategory: "",
    brand: "",
    color: "",
    size: "",
    min_price: "",
    max_price: "",
    available: "",
    sort: "latest",
    page: parseInt(page)
  });

  const queryParams = useMemo(
    () => ({
      q: keyword,
      category: filters.category,
      brand: filters.brand,
      color: filters.color,
      size: filters.size,
      min_price: filters.min_price,
      max_price: filters.max_price,
      available: filters.available,
      sort: filters.sort,
      page: parseInt(page)
    }),
    [keyword, filters, page]
  );

  const { data, isFetching } = useFilterProductsQuery(queryParams);

  useEffect(() => {
    if (!isFetching && keyword) {
      trackAnalytics("search", {
        search_query: keyword,
        metadata: {
          result_count: Number(data?.count || 0),
          page: parseInt(page) || 1,
          sort: filters.sort || "latest"
        }
      });
    }
  }, [isFetching, keyword, data?.count, page, filters.sort]);

  return (
    <>
      <Nav />

      <div className="mt-[76px]">
        <Header>جستجو: {keyword}</Header>
      </div>

      <section className="shop-page">
        <div className="site-container">
          <div className="shop-list-topbar">
            <div className="shop-result-meta">
              <span>{toPersianNumber(data?.count || 0)} محصول</span>
              <strong>نتیجه جستجو برای «{keyword}»</strong>
              <p>نتایج را با فیلتر برند، رنگ، سایز و قیمت دقیق‌تر کن.</p>
            </div>

            <select
              aria-label="مرتب‌سازی محصولات"
              value={filters.sort}
              onChange={(e) => setFilters((prev) => ({ ...prev, sort: e.target.value, page: 1 }))}
            >
              <option value="latest">جدیدترین</option>
              <option value="cheapest">ارزان‌ترین</option>
              <option value="expensive">گران‌ترین</option>
              <option value="popular">محبوب‌ترین</option>
              <option value="discount">بیشترین تخفیف</option>
            </select>
          </div>

          <div className="product-list-layout">
            <ProductFilters
              filters={filters}
              setFilters={setFilters}
              filterOptions={data?.filters || {}}
              count={data?.count || 0}
              open={mobileFilterOpen}
              setOpen={setMobileFilterOpen}
            />

            <section className="product-list-content">
              {isFetching ? (
                <ProductSkeleton />
              ) : data?.count > 0 ? (
                <>
                  <div className="product-grid">
                    {data.products.map((product, index) => (
                      <ProductCard product={product} key={product._id || product.id} index={index} priority={index < 4} />
                    ))}
                  </div>

                  <Pagination page={parseInt(page)} perPage={data.perPage} count={data.count} path={`search-products/${keyword}`} theme="light" />
                </>
              ) : (
                <div className="shop-empty-state">
                  <strong>نتیجه‌ای پیدا نشد</strong>
                  <p>برای «{keyword}» محصولی پیدا نشد. عبارت کوتاه‌تر یا کلمه مشابه را امتحان کن.</p>
                </div>
              )}
            </section>
          </div>
        </div>
      </section>
    </>
  );
};

export default SearchProducts;
